<template>
    <div v-if="pagination && pagination.total && pagination.total > 0">
        <nav v-if="true" class="navbar pagination-nav" role="navigation" :aria-label="$lang('Stronicowanie')">
            <div class="pagination row">
                <div class="col-sm-6 col-12 px-0">
                <paginate
                    v-model="currentPage"
                    :page-count="pagination.last_page || 0"
                    :container-class="'nav'"
                    :page-class="'page-item d-none d-lg-block'"
                    :page-link-class="'page-link'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :next-class="'page-item'"
                    :first-last-button="true"
                    :next-text="this.$lang('Następna') + ' &#8250'"
                    :prev-text="'&#8249 ' + this.$lang('Poprzednia')"
                    :first-button-text="'&#171 ' + this.$lang('Pierwsza')"
                    :last-button-text="this.$lang('Ostatnia') + ' &#187'"
                ></paginate>
                </div>
                <ul class="nav col-sm-6 col-12 px-0 mx-0">
                    <li class="page-item ml-sm-auto ml-2">
                        <span class="navbar-text pages-counter">
                            {{ $lang('Wyświetlanie :from-:to z :total', resultsCountData) }}
                        </span>
                    </li>
                </ul>
            </div>
        </nav>
        <span v-else class="pull-right">
            {{ $lang('Wyświetlanie :from-:to z :total', resultsCountData) }}
        </span>
    </div>
</template>
<script>

    import Paginate from 'vuejs-paginate';
    import { EventBus } from "../mixins/event-bus";

    export default {
        name: 'pagination-component',
        components: { Paginate },
        props: {
            pagination: {
                required: true,
                type: Object | Array
            }
        },
        data() {
            return {
                currentPage: this.pagination.current_page || 1
            };
        },
        watch: {
            currentPage(value) {
                EventBus.$emit('changePage', { value });
            }
        },
        computed: {
            resultsCountData() {
                const { from, to, total } = this.pagination;
                return { from, to, total };
            }
        }
    }

</script>
